module.exports = __webpack_public_path__ + "media/components/assets/cloth_02-8044b73f77327ea554937fd124480c6f.png";